import {BaseEntityConfig, WhiteListFields} from '~/redux/base-entity-config';
import {StudentEntity} from '~/redux/students/types';

class EntityConfig extends BaseEntityConfig<StudentEntity> {
  entityKey = 'students';

  associates = [];

  whiteListFields: WhiteListFields<StudentEntity> = ['*'];

  getAccessors = (value: StudentEntity) => {
    //
  };
}

const studentEntConf = new EntityConfig();

export const studentSchema = studentEntConf.getEntitySchema();

export default studentEntConf;

export const SOURCES_STUDENT = {
  STUDENTS_PAGE: 'STUDENTS_PAGE',
};
